import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { usePaymentLanguage } from '../../lib/paymentLanguage';

type ElqrScreenshotQrProps = { compact?: boolean; amount: string; currency: string } & (
    { value: string; image?: never } | { image: string; value?: never }
);

export const ElqrScreenshotQr: React.FC<ElqrScreenshotQrProps> = ({ compact = false, value, image, amount, currency }) => {
    const { t } = usePaymentLanguage();
    return (
        <div className={compact ? 'elqr-bank-options-compact space-y-3' : 'space-y-3 rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-3'}>
            <div className="mx-auto w-full max-w-[280px] rounded-xl bg-white p-2">
                {image !== undefined ? (
                    <img src={image} alt={t("ElQR для оплаты")} className="h-auto w-full object-contain" />
                ) : (
                    <QRCodeCanvas value={value!} size={560} level="M" marginSize={4}
                        role="img" aria-label={t("ElQR для оплаты")} style={{ width: '100%', height: 'auto' }} />
                )}
            </div>
            <ol className="list-decimal space-y-2 pl-5 text-sm text-gray-600 dark:text-slate-300">
                <li>{t("Сделайте скриншот QR-кода")}</li>
                <li>{t("Откройте приложение банка")}</li>
                <li>{t("Загрузите скриншот и переведите {amount} {currency}", { amount: amount.replace(/\.0+$/, ''), currency })}</li>
            </ol>
        </div>
    );
};
